import Vue from 'vue';
import axios from 'axios';

// Resume axion bearer
axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.tokenTokatab;

Vue.prototype.$axios = axios;
